import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { APP_PATHS } from '../config/app-paths';

export const TermsAndConditionsBlockGuard: CanActivateFn = (_, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.checkTermsAndConditions$().pipe(
    map((termsChanged) => {
      return termsChanged ? true : router.createUrlTree([`${APP_PATHS.home}`]);
    }),
    take(1),
  );
};
